import { showErrorNotification } from '@/utils/utils';

const state = {
  isRegistrantsActivityEnabled: false,
  isRegistrantsActivityEnableLoading: false,
  registrantsActivityEnableError: null,
  userGroupToken: '',
  isUserGroupTokenLoading: false,
  userGroupTokenError: null,
  userProfile: {},
  isUserProfileLoading: false,
  userProfileError: null
};

const mutations = {
  setRegistrantsActivityEnableLoading(state, isRegistrantsActivityEnableLoading) {
    state.isRegistrantsActivityEnableLoading = isRegistrantsActivityEnableLoading;
  },
  setRegistrantsActivityEnabled(state, isRegistrantsActivityEnabled) {
    state.isRegistrantsActivityEnabled = isRegistrantsActivityEnabled;
  },
  setRegistrantsActivityEnableError(state, registrantsActivityEnableError) {
    state.registrantsActivityEnableError = registrantsActivityEnableError;
  },
  setUserGroupToken(state, token) {
    state.userGroupToken = token;
  },
  setUserGroupTokenLoading(state, isUserGroupTokenLoading) {
    state.isUserGroupTokenLoading = isUserGroupTokenLoading;
  },
  setUserGroupTokenError(state, userGroupTokenError) {
    state.userGroupTokenError = userGroupTokenError;
  },
  setUserProfile(state, userProfile) {
    state.userProfile = userProfile;
  },
  setUserProfileLoading(state, isUserProfileLoading) {
    state.isUserProfileLoading = isUserProfileLoading;
  },
  setUserProfileError(state, userProfileError) {
    state.userProfileError = userProfileError;
  }
};

const actions = {
  async fetchRegistrantsActivityEnable(context, shortUrl) {
    context.commit('setRegistrantsActivityEnableLoading', true);

    try {
      const response = await context.dispatch(
        'makeapicall',
        {
          url: `/core/registrant_activity_url/is_enabled/?short_url=${shortUrl}`,
          method: 'GET'
        },
        { root: true }
      );
      context.commit('setRegistrantsActivityEnabled', response?.is_registrant_activity_enabled);
    } catch (error) {
      context.commit('setRegistrantsActivityEnableError', error?.message);
    } finally {
      context.commit('setRegistrantsActivityEnableLoading', false);
    }
  },

  async fetchUserGroupToken(context, shortUrl) {
    context.commit('setUserGroupTokenLoading', true);

    try {
      const response = await context.dispatch(
        'makeapicall',
        {
          url: `/core/registrant_activity_url/explo_token/?short_url=${shortUrl}`,
          method: 'GET'
        },
        { root: true }
      );
      context.commit('setUserGroupToken', response.token);
    } catch (error) {
      try {
        const errorCode = JSON.parse(error).code;
        context.commit('setUserGroupTokenError', errorCode);
      } catch {
        context.commit('setUserGroupTokenError', error);
      }
    } finally {
      context.commit('setUserGroupTokenLoading', false);
    }
  },

  async fetchRegistrantProfile(context, shortUrl) {
    context.commit('setUserProfileLoading', true);

    try {
      const orgID = context.rootGetters['org/getCurrentOrgId'];
      const response = await context.dispatch(
        'makeapicall',
        {
          url: `/core/registrant_activity_url/registrant_profile/?short_url=${shortUrl}&organization_id=${orgID}`,
          method: 'GET'
        },
        { root: true }
      );
      context.commit('setUserProfile', response);
    } catch (error) {
      try {
        const errorCode = JSON.parse(error).code;
        context.commit('setUserProfileError', errorCode);
      } catch {
        context.commit('setUserProfileError', error);
        showErrorNotification('Error in fetching user profile information! Please try again.');
      }
    } finally {
      context.commit('setUserProfileLoading', false);
    }
  }
};

export default {
  state,
  mutations,
  actions,
  namespaced: true
};
